import { CompanyDto } from './company-dto.model';
import { BranchDto } from './branch-dto.model';


export class AssetMasterDto implements IAssetMasterDto {
    id!: number;
    name!: string | undefined;
    quantity!: number;
    branchId!: number;
    companyId!: number;
    company!: CompanyDto;
    branch!: BranchDto;

    constructor(data?: IAssetMasterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.branchId = _data["branchId"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.branch = _data["branch"] ? BranchDto.fromJS(_data["branch"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AssetMasterDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMasterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["branchId"] = this.branchId;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["branch"] = this.branch ? this.branch.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAssetMasterDto {
    id: number;
    name: string | undefined;
    quantity: number;
    branchId: number;
    companyId: number;
    company: CompanyDto;
    branch: BranchDto;
}

